import React, { useState, useEffect, useRef } from 'react'
import { makeStyles, Box, Typography } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useGoogleLogin } from '@react-oauth/google'
// import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import landing_page_phone from "../images/landing_page_phone.png"

// Registration / Auth utilities
import { showToast } from '../../../../utils/toast'
import { registerUser } from '../../../../features/auth/services'
import { googleSignInAPI } from '../../../../api/userApi'
import { setUser } from '../../../../redux/modules/userSlice'
import { setTokens } from '../../../../utils/tokens'
import {
    trackReferralAttributedStage,
    trackSignupCompleted,
    trackSignupStarted,
} from '../../../../analytics/canonicalTracking'
import { isStagingCreatorOnboardingBypassEnabled } from '../../../../config/stagingCreatorOnboarding'
import {
    aliasMixpanelUser,
    identifyMixpanelUser,
    setMixpanelPeopleProfile,
} from '../../../../config/mixpanel'

const useStyles = makeStyles((theme) => ({
    signupSectionOuter: {
        width: '100%',
        background: "#131313",
        overflow: 'hidden',
        position: 'relative',
    },
    ellipse: {
        position: 'absolute',
        top: '-300px',
        left: '-300px',
        width: '498px',
        height: '423px',
        borderRadius: '50%',
        background: '#FE5A97',
        filter: 'blur(100px)',
        opacity: 0.3,
        pointerEvents: 'none',
        zIndex: 1,
    },
    signupSection: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        padding: "60px 24px 0px 24px",
        maxWidth: 1314,
        margin: "0 auto",
        boxSizing: 'border-box',
        position: 'relative',
        zIndex: 2,
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            gap: '20px',
            overflow: 'hidden',
            padding: "36px 21px 0px 21px",
        },
    },
    signupContent: {
        flex: 1,
        maxWidth: 530,
        display: "flex",
        paddingBottom: "50px",
        flexDirection: "column",
        justifyContent: "center",
        [theme.breakpoints.down('md')]: {
            margin: '0 auto',
            width: '100%',
            paddingBottom: "36px",
        }
    },
    signupTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: '52px',
        fontWeight: 400,
        marginBottom: '16px',
        lineHeight: '100%',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            fontSize: '36px',

        }
    },
    signupSubtitle: {
        fontSize: '18px',
        color: '#ffffff',
        marginBottom: '30px',
        lineHeight: "27px",
        fontWeight: 200,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            fontSize: '16px',
            marginBottom: '30px',
            width: '90%',
            marginLeft: "auto",
            marginRight: 'auto'
        }
    },
    signupForm: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        [theme.breakpoints.down('sm')]: {
            gap: '12px',
        }
    },
    signupInputWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
    signupInput: {
        width: '100%',
        height: '51px',
        background: '#1B1B1B',
        border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: '6px',
        color: 'white',
        padding: '16px',
        fontSize: '14px',
        outline: 'none',
        [theme.breakpoints.down('sm')]: {
            height: '45px'
        },
        '&::placeholder': {
            color: 'rgba(255,255,255,0.4)',
        }
    },
    passwordIcon: {
        position: 'absolute',
        right: '16px',
        cursor: 'pointer',
        opacity: 0.5,
    },
    signupButton: {
        fontFamily: "'Roboto', sans-serif",
        height: "48px",
        marginTop: "6px",
        background: 'linear-gradient(90deg, #87959C, #89959B, #8B949B, #B1B3BB, #C3C8CC, #F1F2F4, #D2DBE6, #9AB0B7, #A5B7C0 )',
        color: 'black',
        fontWeight: 600,
        border: 'none',
        padding: '13px',
        borderRadius: '6px',
        fontSize: '16px',
        cursor: 'pointer',
        transition: 'transform 0.2s',
        [theme.breakpoints.down('sm')]: {
            height: "42px",
            fontWeight: 500,
            padding: '9px',
        },
        '&:hover': {
            transform: 'translateY(-1px)',
        }
    },
    dividerBox: {
        display: 'flex',
        alignItems: 'center',
        margin: '0px 0',
        color: 'rgba(255,255,255)',
        fontSize: '16px',
        lineHeight: "24px",
        [theme.breakpoints.down('sm')]: {
            // fontSize: '14px',
        },
        '&::before, &::after': {
            content: '""',
            flex: 1,
            borderBottom: '1px solid rgba(255,255,255,0.1)',
            margin: '0 10px',
        }
    },
    googleButton: {
        height: "48px",
        background: 'transparent',
        border: '1px solid rgba(255,255,255,1)',
        borderRadius: '6px',
        color: 'white',
        padding: '14px',
        fontSize: '14px',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        cursor: 'pointer',
        transition: 'background 0.2s',
        [theme.breakpoints.down('sm')]: {
            height: "42px",
        },
        '&:hover': {
            background: 'rgba(255,255,255,0.05)',
        }
    },
    mockupContainer: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
            width: '100%',
        }
    },
    mockupImage: {
        width: '120%',
        maxWidth: '120%',
        maxHeight: '780px',
        objectFit: 'contain',
        display: 'block',
        marginRight: '-10%',
        [theme.breakpoints.down('md')]: {
            width: '144%',
            maxWidth: '144%',
            maxHeight: '656px',
            marginRight: 0,
        }
    },
}))

export const SignupSection: React.FC = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    // Get referral ID from URL params
    const [referralId, setReferralId] = useState<string | null>(null)

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const ref = searchParams.get("ref")
        if (ref) {
            setReferralId(ref)
        }
    }, [location.search])

    const signupStartedTracked = useRef(false)
    useEffect(() => {
        if (signupStartedTracked.current) return
        signupStartedTracked.current = true
        const sp = new URLSearchParams(location.search)
        trackSignupStarted({
            path: location.pathname,
            user_role: "guest",
            signup_method: "email_password",
            source: sp.get("utm_source") || undefined,
            medium: sp.get("utm_medium") || undefined,
            campaign: sp.get("utm_campaign") || undefined,
        })
    }, [location.pathname, location.search])

    // const { executeRecaptcha } = useGoogleReCaptcha()

    const googleRegistration = useGoogleLogin({
        onSuccess: async (tokenResponse: { access_token: string }) => {
            try {
                const userInfoResponse = await fetch(
                    "https://www.googleapis.com/oauth2/v3/userinfo",
                    {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.access_token}`,
                        },
                    }
                )
                const userInfo = await userInfoResponse.json()

                const searchParams = new URLSearchParams(location.search)
                const ref = searchParams.get("ref")

                googleSignInAPI({
                    google_access_token: tokenResponse.access_token,
                    email: userInfo.email,
                    name: userInfo.name,
                    picture: userInfo.picture,
                    referralId: ref || undefined,
                })
                    .then(response => {
                        showToast(response.data.message || "Registration successful!")
                        setTokens(response.data.tokens)
                        dispatch(setUser(response.data.user))
                        const u = response.data.user
                        const role = u?.userType?.title?.toLowerCase?.() || "guest"
                        aliasMixpanelUser(u?.id)
                        identifyMixpanelUser(u?.id)
                        setMixpanelPeopleProfile({
                            email: u?.email || userInfo?.email,
                            name: u?.username || userInfo?.name,
                        })
                        trackSignupCompleted({
                            user_id: u?.id,
                            user_role: role === "viewer" || role === "creator" ? role : "guest",
                            signup_method: "google_oauth",
                            source: new URLSearchParams(location.search).get("utm_source") || undefined,
                            medium: new URLSearchParams(location.search).get("utm_medium") || undefined,
                            campaign: new URLSearchParams(location.search).get("utm_campaign") || undefined,
                        })
                        if (ref) {
                            trackReferralAttributedStage({
                                referral_stage: "signup",
                                referrer_user_id: ref,
                                user_id: u?.id,
                                user_role: role === "viewer" || role === "creator" ? role : "guest",
                            })
                        }
                        localStorage.setItem("hasRegisteredOrLoggedIn", "true")
                        showToast("Login successful!")
                        history.push("/")
                    })
                    .catch(err => {
                        const errorMessage =
                            err?.response?.data?.message ||
                            err?.message ||
                            "Registration API error"
                        showToast(errorMessage, "error")
                    })
            } catch (error: any) {
                console.error("Google registration error:", error)
                const errorMessage =
                    error?.response?.data?.message ||
                    error?.message ||
                    "Error while signing in with Google!"
                showToast(errorMessage, "error")
            }
        },
        onError: () => {
            showToast("Error while signing in with Google!", "error")
        },
    })

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === "Enter") {
            void handlerSubmit()
        }
    }

    const handlerSubmit = async () => {
        const emailTrim = email.trim()
        const passTrim = password.trim()

        if (!emailTrim || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailTrim)) {
            showToast("Please enter a valid email address", "error")
            return
        }

        const isPasswordValid = 
            passTrim.length >= 8 &&
            passTrim.length <= 128 &&
            /[A-Z]/.test(passTrim) &&
            /[a-z]/.test(passTrim) &&
            /[0-9]/.test(passTrim) &&
            /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(passTrim)

        if (!isPasswordValid) {
            showToast("Password must be at least 8 characters long and include an uppercase letter, lowercase letter, number, and special character.", "error")
            return
        }

        setIsLoading(true)

        try {
            // if (!executeRecaptcha) {
            //     showToast("reCAPTCHA not ready. Please try again.", "error")
            //     return
            // }
            // await executeRecaptcha("signup")

            const result = await registerUser(
                email,
                password,
                referralId ? referralId : undefined
            )

            if (result.success) {
                localStorage.setItem("user", JSON.stringify(result.user))
                localStorage.setItem("hasRegisteredOrLoggedIn", "true")

                const sp = new URLSearchParams(location.search)
                const u = result.user as { id?: string; userType?: { title?: string } }
                const role = u?.userType?.title?.toLowerCase?.() || "guest"
                aliasMixpanelUser(u?.id)
                identifyMixpanelUser(u?.id)
                setMixpanelPeopleProfile({ email, name: null })
                trackSignupCompleted({
                    user_id: u?.id,
                    user_role: role === "viewer" || role === "creator" ? role : "guest",
                    signup_method: "email_password",
                    source: sp.get("utm_source") || undefined,
                    medium: sp.get("utm_medium") || undefined,
                    campaign: sp.get("utm_campaign") || undefined,
                })
                if (referralId) {
                    trackReferralAttributedStage({
                        referral_stage: "signup",
                        referrer_user_id: referralId,
                        user_id: u?.id,
                        user_role: role === "viewer" || role === "creator" ? role : "guest",
                    })
                }

                showToast(result.message || "User registered successfully!")

                if (isStagingCreatorOnboardingBypassEnabled()) {
                    dispatch(setUser(result.user))
                    history.push("/choose-user-type")
                } else {
                    history.push("/email-activation", { userData: result.user })
                }
            } else {
                showToast("Registration failed. Please try again.", "error")
            }
        } catch (err: any) {
            if (typeof err === "string") {
                showToast(err, "error")
                return
            }

            const serverMessage =
                err?.response?.data?.message || err?.response?.message

            if (serverMessage) {
                showToast(serverMessage, "error")
            } else if (
                err.code === "auth/email-already-in-use" ||
                err.customData?._tokenResponse?.error?.message === "EMAIL_EXISTS"
            ) {
                showToast("This email already in use!", "error")
            } else if (err.message?.includes("reCAPTCHA")) {
                showToast("reCAPTCHA verification failed. Please try again.", "error")
            } else {
                showToast(err?.message || "Error while registering user!", "error")
            }
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Box className={classes.signupSectionOuter}>
            <div className={classes.ellipse} />
            <Box className={classes.signupSection}>
                <Box className={classes.signupContent}>
                    <Typography variant="h2" className={classes.signupTitle}>
                        Ready to Join?<br />Sign Up Today.
                    </Typography>
                    <Typography className={classes.signupSubtitle}>
                        Join the community and start connecting with creators today.
                    </Typography>
                    <Box className={classes.signupForm}>
                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={classes.signupInput}
                        />
                        <Box className={classes.signupInputWrapper}>
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className={classes.signupInput}
                                onKeyPress={handleKeyPress}
                            />
                            <svg 
                                className={classes.passwordIcon} 
                                width="20" 
                                height="20" 
                                viewBox="0 0 24 24" 
                                fill="none" 
                                stroke="white" 
                                strokeWidth="2" 
                                strokeLinecap="round" 
                                strokeLinejoin="round"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{ cursor: 'pointer' }}
                            >
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                <circle cx="12" cy="12" r="3"></circle>
                            </svg>
                        </Box>
                        <button 
                            className={classes.signupButton} 
                            onClick={handlerSubmit}
                            disabled={isLoading}
                        >
                            {isLoading ? "Signing up..." : "Join As A Member"}
                        </button>

                        <Box className={classes.dividerBox}>or continue with</Box>

                        <button 
                            className={classes.googleButton} 
                            onClick={() => googleRegistration()}
                            disabled={isLoading}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                            </svg>
                            Sign Up With Google
                        </button>
                    </Box>
                </Box>
                <Box className={classes.mockupContainer}>
                    <img src={landing_page_phone} alt="App Mockup" className={classes.mockupImage} />
                </Box>
            </Box>
        </Box>
    )
}
